export default __webpack_public_path__ + "static/data-unions@2x-fbb7946c2a4cb659f2ee2ea7bdd688b3.png";